import { render, staticRenderFns } from "./MenuHeader.vue?vue&type=template&id=202fdaf4&scoped=true&"
import script from "./MenuHeader.vue?vue&type=script&lang=js&"
export * from "./MenuHeader.vue?vue&type=script&lang=js&"
import style0 from "./MenuHeader.vue?vue&type=style&index=0&id=202fdaf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202fdaf4",
  null
  
)

export default component.exports